import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../base-component'
import { isEnterKey } from 'src/scripts/utils/key'
import { debounce } from 'src/scripts/utils/debounce'

const BUTTON_SELECTOR = '[data-back-to-top-button]'

export class BackToTopButton extends BaseComponent {
  lastPosition = 0
  mountComponent(): void {
    this.addListener(this, 'keydown', this.handleKeydown)
    this.addListener(this, 'click', this.handleButtonClick)
    this.addListener(window, 'scroll', this.handleWindowScroll)
  }

  handleWindowScroll = debounce((): void => {
    const button = $el(BUTTON_SELECTOR, this)
    const { scrollY, innerHeight } = window

    button?.classList.toggle(
      'is-visible',
      scrollY > innerHeight && scrollY < this.lastPosition,
    )

    this.lastPosition = scrollY === 0 ? this.lastPosition + 1 : scrollY
  }, 100)

  handleButtonClick = (): void => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  handleKeydown = (event: KeyboardEvent): void => {
    if (isEnterKey(event)) {
      const skipContent = $el('#SkipContent')
      window.scrollTo({ top: 0, behavior: 'instant' })
      skipContent.focus()
    }
  }
}
